<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="우리말 문장을 보며 영어로 말하세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="ww-jumbotron-content-sentence lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg mb-base text-center">
        <p class="text-primary font-bold">{{ content.translation }}</p>
      </div>
      <div v-show="hint" class="ww-jumbotron-content-translation lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg mb-base text-center" >
        <p class="text-success font-bold">{{ content.sentence }}</p>
      </div>
      
      <div>
        <vs-alert  v-show="!recordingFinished" class="mt-3 text-center" >
          아래 버튼을 누른 상태에서 녹음을 진행합니다. 녹음이 끝나면 버튼을 놓으세요.
        </vs-alert>

        <div class="text-center mt-3">
          <vue-record-audio v-show="!recordingFinished" :mode="recordMode.audio" @result="onResult" />
          <div v-show="recordingFinished" class="text-center mt-3">
            <audio ref="userAudioPlayer" :src="recording" controls v-on:ended="userAudioFinish"  />
          </div>
        </div>
      </div>

      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            hidden
            v-on:ended="audioFinish" 
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      recordMode: {
        audio: 'hold',
        video: 'press'
      },
      hint: false,
      recording: '',
      recordingFinished: false
    }
  },
  watch: {
    sourceContent () {
      this.onReload()
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    userAudioPlayer () {
      return this.$refs.userAudioPlayer
    }
  },
  methods: {
    onResult (data) {
      this.recording = window.URL.createObjectURL(data)
      this.recordingFinished = true
      this.hint = true

      setTimeout(function () {
        this.userAudioPlayer.play()
      }.bind(this), 1000)
      
    },
    onReload () {
      this.contentIndex = 0
      this.recordingFinished = false
      this.startAlert()
    },
    playAudio () {
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    audioFinish () {
      setTimeout(function () {

        if (this.contentIndex >= this.contentsLen - 1) {
          this.onComplete()
        } else {
          this.contentIndex++
          this.hint = false
          this.recordingFinished = false
        }
      }.bind(this), 1000)

    },
    userAudioFinish () {
      setTimeout(function () {
        this.playAudio()
      }.bind(this), 1000)
    },
    startAlert () {
      this.startStudyDlg('우리말 문장을 보며 영어로 말하기 연습합니다.')
    },
    acceptAlert () {
    },
    onHint () {
      this.hint = true
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }

    // this.contentList = [
    //   {
    //     sentence: 'Who is next?',
    //     translation: '누가 다음 차례지?'
    //   },
    //   {
    //     sentence: 'Who is first?',
    //     translation: '누가 처음이지?'
    //   },
    //   {
    //     sentence: 'Who is bigger?',
    //     translation: '누가 더 크지?'
    //   },
    //   {
    //     sentence: 'Who is last?',
    //     translation: '누가 두번째이지?'
    //   },
    //   {
    //     sentence: 'Who is second?',
    //     translation: '다음의'
    //   },
    //   {
    //     sentence: 'Who is shorter?',
    //     translation: '누가 더 작지?'
    //   },
    //   {
    //     sentence: 'Who is taller?',
    //     translation: '누가 더 크지?'
    //   }
      
    // ]
    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
</style>